module.exports = __webpack_public_path__ + "media/scholarship_winners/katlyn-sw-c74de30f.png";